import { ComponentThemeType } from './theme.types';

export const iconsTheme: ComponentThemeType = {
  MuiSvgIcon: {
    styleOverrides: {
      colorAction: ({ theme }) => theme.palette.action.activatedOpacity,
    },
  },
};
